import api from "../api";

const tutorial_module = {
  state: {
    sections: [],
    progress: [],
    loaded: false,
  },
  getters: {
    getTutorialSections: (state) => state.sections,
    getTutorialProgress: (state) => state.progress,
    isTutorialLoaded: (state) => state.loaded,
    isSectionCompleted: (state) => (sectionKey) => {
      return state.progress.includes(sectionKey);
    },
  },
  mutations: {
    setTutorialSections(state, sections) {
      state.sections = sections;
    },
    setTutorialProgress(state, progress) {
      state.progress = progress;
    },
    setTutorialLoaded(state, loaded) {
      state.loaded = loaded;
    },
    addCompletedSection(state, sectionKey) {
      if (!state.progress.includes(sectionKey)) {
        state.progress.push(sectionKey);
      }
    },
    clearTutorialProgress(state) {
      state.progress = [];
    },
  },
  actions: {
    async fetchTutorials({ commit }) {
      try {
        const response = await api.get("tutorial/sections");
        commit("setTutorialSections", response.data.sections);
        commit("setTutorialLoaded", true);
      } catch (error) {
        console.error("Error fetching tutorials:", error);
      }
    },
    async fetchTutorialProgress({ commit, rootGetters }) {
      try {
        const user = rootGetters.getInfoUser;
        if (!user) return;
        const response = await api.get("tutorial/progress", {
          user_id: user.id,
        });
        commit("setTutorialProgress", response.data.completed);
      } catch (error) {
        console.error("Error fetching tutorial progress:", error);
      }
    },
    async markTutorialComplete({ commit, rootGetters }, sectionKey) {
      try {
        const user = rootGetters.getInfoUser;
        if (!user) return;
        await api.post("tutorial/complete", {
          user_id: user.id,
          section_key: sectionKey,
        });
        commit("addCompletedSection", sectionKey);
      } catch (error) {
        console.error("Error marking tutorial complete:", error);
      }
    },
    async resetTutorialProgress({ commit, rootGetters }) {
      try {
        const user = rootGetters.getInfoUser;
        if (!user) return;
        await api.post("tutorial/reset", {
          user_id: user.id,
        });
        commit("clearTutorialProgress");
      } catch (error) {
        console.error("Error resetting tutorial progress:", error);
      }
    },
  },
};

export default tutorial_module;
